import { termsService } from '@/services/terms';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface AcceptTermsParams {
  termsVersion: string;
}

interface AcceptTermsResult {
  success: boolean;
  message?: string;
  error?: string;
}

export const useAcceptTerms = () => {
  const queryClient = useQueryClient();

  return useMutation<AcceptTermsResult, Error, AcceptTermsParams>({
    mutationFn: async ({ termsVersion }) => {
      const result = await termsService.acceptTerms(termsVersion);

      if (!result.success) {
        throw new Error(result.error || 'Erro ao aceitar termos de uso');
      }

      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['terms'] });
    },
    onError: error => {
      console.error('Erro ao aceitar termos:', error);
    },
  });
};
